import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { RoutesConstants } from '../../../shared/constants';
import { AppTypeEnum } from '../../../shared/enums';
import { NavigatorHelper } from '../../../shared/helpers';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../../../shared/dialogs/info-dialog/info-dialog.component';

@Component({
  selector: 'app-binding-home',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './binding-home.component.html',
  styleUrl: './binding-home.component.scss'
})
export class BindingHomeComponent {

  constructor(
    private router: Router,
    private dialog: MatDialog
  ) { }

  public startApp() {
    NavigatorHelper.setAppType(AppTypeEnum.binding);
    this.router.navigate([RoutesConstants.BINDING_START]);
  }

  public openInfo() {
    this.dialog.open(InfoDialogComponent, {
      data: { appType: AppTypeEnum.binding },
      panelClass: 'info-dialog',
    });
  }

}
